import _ from 'lodash';
export var positionsMapping = {
  'top center': 'top',
  'top left': 'top-start',
  'top right': 'top-end',
  'bottom center': 'bottom',
  'bottom left': 'bottom-start',
  'bottom right': 'bottom-end',
  'right center': 'right',
  'left center': 'left'
};
export var positions = _.keys(positionsMapping);
export var placementMapping = _.invert(positionsMapping);
//# sourceMappingURL=positions.js.map